/**
 * Javascript specific to the mobile header
 */
define(['jquery', 'domReady!'], ($) => {

    function handlerMobileToggleSearchClick(e) {
        e.preventDefault();

        $(".js-aligent_fredhopper-autocomplete-wrapper").toggleClass("search-visible");

        var $headerMinisearch1 = $('.site-header__mobile-top .minisearch');

        if ($(".checkout-cart-index").length > 0) {
            if ($(".js-aligent_fredhopper-autocomplete-wrapper").hasClass("search-visible")) {
                $headerMinisearch1.addClass('hidden'); 
            }           
        }
          
        if ($headerMinisearch1.hasClass('hidden')) {
            $headerMinisearch1.removeClass('hidden');
            $(".minisearch .minisearch__control--submit").show();
            $(".minisearch .minisearch__control--submit:after").show();
            $(".checkout-cart-index .minisearch__control").show();
        }
        else {
            $headerMinisearch1.addClass('hidden');
            $(".minisearch .minisearch__control--submit").hide();
            $(".minisearch .minisearch__control--submit:after").hide();
            $(".checkout-cart-index .minisearch__control").hide();        
        }
    }

    $(document.body).on('click', '.mobile-header-search-toggle', handlerMobileToggleSearchClick);

    function handlerMobileHeaderSearchClick(e) {
        e.preventDefault();

        const $headerMinisearch = $('.site-header__mobile-top .minisearch'); // Be sure to only target the mobile one
        const $headerMinisearchText = $headerMinisearch.find('.minisearch__control--text');

        // Automatic focus on the search field so the user can start typing right away
        $headerMinisearchText.on('focus', function () {
            // Javascript hack that will set the cursor to the end of the current value of the search field, if one is
            // already there. Makes it easier for the user to perform subsequent searches
            this.value = this.value;
            $(".mobile-search-clear-btn").show(); // Show the X to clear
        });
        $headerMinisearchText.focus();
    }

    $(document.body).on('click', '.site-header__mobile-top .minisearch', handlerMobileHeaderSearchClick);

    //To clear the input text on click of clear button

    function handleClearSearch(e) {
        e.stopPropagation();
        $(".site-header__mobile-top input.minisearch__control").val('');
    }

    $(document.body).on('touchstart', '.mobile-search-clear-btn', handleClearSearch);

    //To search the value on click of submit button

    function handleSearchSubmit(e) {
        e.preventDefault();
        if ($(".site-header__mobile-top input.minisearch__control").val() != "") {
            $("#mobile_header_search_mini_form").submit();
        }
    }

    $(document.body).on('click', '.minisearch .minisearch__control--submit', handleSearchSubmit);

    // Toggle clear and search icons
    function handleFocusClass(e) {
        e.preventDefault();
        let input = $(".site-header__mobile-top input.minisearch__control");
        input.on('focus', function () {
            $(".site-header__mobile-top").addClass("focused-input");
        });
        input.on('blur', function () {
            $(".site-header__mobile-top").removeClass("focused-input");
            $(".mobile-search-clear-btn").hide(); // Hide the X to clear
        });
    }

    $(document.body).on('click', '.site-header__mobile-top #mobile-search', handleFocusClass);

    // Move search IN TO mobile menu
    function showSearchInMobileMenu(e) {
        e.preventDefault();

        $(".js-aligent_fredhopper-autocomplete-wrapper").prependTo(".mobile-navigation-container");

        // Add remove classes as needed
        $(".navigation-bar-mobile__toggle").removeClass("menu-toggle-not-shown").addClass("menu-toggle-is-shown");
        $(".js-aligent_fredhopper-autocomplete-wrapper").addClass("mobile-menu-shown");
    }

    $(document.body).on('click', '.menu-toggle-not-shown', showSearchInMobileMenu);

    // Move search OUT OF mobile menu
    function hideSearchInMobileMenu(e) {
        e.preventDefault();

        $(".js-aligent_fredhopper-autocomplete-wrapper").appendTo(".site-header__mobile-top");

        // Add remove classes as needed
        $(".navigation-bar-mobile__toggle").removeClass("menu-toggle-is-shown").addClass("menu-toggle-not-shown");
        $(".js-aligent_fredhopper-autocomplete-wrapper").removeClass("mobile-menu-shown");
    }

    $(document.body).on('click', '.menu-toggle-is-shown', hideSearchInMobileMenu);
});
